import { setUserCardOpened } from './actions';
import { trackOpenUserCard } from './tracking';
import { currentChatOpponentIdSelector, currentOpenChatSelector } from '../../selectors';
import { TThunkAction } from '../../types/redux/thunk';

export const openUserCard =
  (userId: number): TThunkAction<void> =>
  (dispatch, getState) => {
    const state = getState();

    const currentChat = currentOpenChatSelector(state);
    const opponentId = currentChatOpponentIdSelector(state);

    dispatch(setUserCardOpened());
    trackOpenUserCard(currentChat, userId, opponentId);
  };
